import React, {useState, useEffect} from "react";
import SideMenu from "../SideMenu";
import {convertJSONintoPreferredSideBarFormat} from "../../utils/sideBarUtils";
import {useMyContext} from "../../context/MyContext";
import {useParams} from "react-router-dom";
import MethodContainer from "../MethodContainer";
import {SideMenuContextProvider} from "../../context/SideMenuContext";
import Loader from "../Loader/Loader";
import dataFile from "../../Data/dataFile.json";
import * as Constants from "../../constants/Constants";
import {Helmet} from "react-helmet";
import {SeoTitles} from "../../constants/Constants";

const Layout = ({component}) => {
  const {version, entity, setEntity, setVersion} = useMyContext();
  const [data, setData] = useState();
  const {id} = useParams();

  const formattedID = id.replace("-", " ");
  setEntity(formattedID);
  const [apiData, setApiData]=useState();
  const [subMenuData, setSubMenuData] = useState();
  const [groupedByTags, setgroupedByTags] = useState();
  const [schemas, setSchemas] = useState();
  const [schemasWithRefs, setSchemasWithRefs] = useState();
  const [display, setDisplay] = useState(false);
  // const ENTITIES_CONFIG = dataFile["entitiesConfig"];

  const entityVersionMap = dataFile["entityVersionMap"];
  const entitiesConfig = dataFile["entitiesConfig"];

  const allVersions = dataFile["allVersions"];

  useEffect(()=>{
    if (component=== Constants.Values.SINGLE_API && entity) {
      const versions = entityVersionMap[entity];
      setVersion(versions[0]);
    }

    if (component === Constants.Values.VIEW_DOCUMENTATION ) {
      setVersion(allVersions[0]);
    }
  }, [entity]);

  useEffect(() => {
    setTimeout(()=>{
      if (version) {
        const importComponent = async () => {
          const module = await import(`../../Data/${version}.json`);
          setData(module);
        };

        importComponent();
      }
    }, 500);
  }, [version]);
  useEffect(()=>{
    if (data) {
      setDisplay(true);
      const apiData = {[formattedID]: data[formattedID]};
      if (apiData[formattedID]) {
        setApiData(apiData);
        setDisplay(true);
        const subMenuData = convertJSONintoPreferredSideBarFormat(apiData);
        const groupedByTags = Object.values(apiData).reduce((acc, {SubEntities}) => {
          const tagsArray = SubEntities?.map(({id, name, description, tags}) => ({
            name,
            description,
            tags,
            id,
          }));
          acc.push(...tagsArray);
          return acc;
        }, []);

        const schemas = Object.entries(apiData[formattedID]?.schemas[0] || {});
        const schemasWithRefs = Object.entries(apiData[formattedID]?.schemasWithRefs[0] || {});
        setApiData(apiData);
        setSubMenuData(subMenuData);
        setgroupedByTags(groupedByTags);
        setSchemas(schemas);
        setSchemasWithRefs(schemasWithRefs);
        document.documentElement.scrollTop = 0;
      } else {
        setDisplay(false);
      }
    }
  }, [data]);



  if (!data||!display) {
    return <Loader/>;
  }
  return (
    <>
      <SideMenuContextProvider>
        <Helmet>
          <title>{SeoTitles[formattedID]}</title>
          <meta name="description" content= {entitiesConfig[formattedID]?.desc} />
        </Helmet>
        <SideMenu menu={subMenuData} component={Constants.Values.SINGLE_API}/>
        <div className="page-wrapper">
          <div className="content">
            <MethodContainer groupedByTags={groupedByTags} schemas={schemas} schemasWithRefs={schemasWithRefs} component="SinglePage"/>;
          </div>
        </div>
      </SideMenuContextProvider>
    </>
  );
};

export default Layout;
